import { Stack, Text } from '@chakra-ui/react';
import { PortableText } from '@portabletext/react';
import type { FullscreenPopup } from 'types/cms/Globals';

type TextContentProps = Pick<FullscreenPopup, 'overlineText' | 'title'>;

const portableTextComponents = {
  block: ({ children }: { children?: React.ReactNode }) => <>{children}</>,
};

export const TextContent = ({ overlineText, title }: TextContentProps) => (
  <Stack gap="3xs" textAlign="center">
    {overlineText && (
      <Text
        size="overline"
        sx={{ textWrap: 'balance' }}
        px={{ base: 'xs', md: 0 }}
      >
        {overlineText}
      </Text>
    )}
    <Text size="h2" sx={{ textWrap: 'balance' }}>
      <PortableText value={title} components={portableTextComponents} />
    </Text>
  </Stack>
);
